export const DepartmentUserList = [
    {
        prop: "departmentUserId",
        label: "departmentUserId",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "code",
        label: "成员账号",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "name",
        label: "成员名称",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "nickName",
        label: "昵称",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "phone",
        label: "手机号",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
]



